import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contractServicePartner'

function* fetchContractServicePartnersRefresh() {
  try {
    let fe = JSON.parse(localStorage.getItem('fetchContractServicePartners'))
    if (fe == null) {
      fe = { size: 10, index: 0, searchTerm: '%20', orderBy: '%20' }
    }
    const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
    yield put({
      type: actions.LIST_CONTRACTSERVICEPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractServicePartnersRefresh error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartners({ size, index, searchTerm, orderBy }) {
  try {
    // Load last params from last session.
    if (!size && !index && !searchTerm && !orderBy) {
      const fe = JSON.parse(localStorage.getItem('fetchContractServicePartners'))
      if (fe != null) {
        size = fe.size || 10
        index = fe.index || 0
        searchTerm = fe.searchTerm || '%20'
        orderBy = fe.orderBy || '%20'
      } else {
        size = 10
        index = 0
        searchTerm = '%20'
        orderBy = '%20'
      }
    }
    localStorage.setItem(
      'fetchContractServicePartners',
      JSON.stringify({ size, index, searchTerm, orderBy }),
    )
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(list, size, index, searchTerm, orderBy)
    yield put({
      type: actions.LIST_CONTRACTSERVICEPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractServicePartners error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerEdit({ id }) {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(find, id)
    yield put({
      type: actions.EDIT_CONTRACTSERVICEPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractServicePartnerEdit error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerSave(values) {
  try {
    const result = yield call(save, values)
    if (result !== null) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    }
    yield put({
      type: actions.SAVE_CONTRACTSERVICEPARTNER_RECIEVED,
      result,
    })
    yield put({
      type: actions.RE_FETCH_CONTRACTSERVICEPARTNERS,
    })
  } catch (e) {
    console.error('fetchContractServicePartnerSave error', e)
    notification.error({ message: 'Save failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerDelete(values) {
  try {
    const result = yield call(remove, values)
    if (result !== null) {
      notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
    }
    yield put({
      type: actions.DELETE_CONTRACTSERVICEPARTNER_RECIEVED,
      result,
    })
    yield put({
      type: actions.RE_FETCH_CONTRACTSERVICEPARTNERS,
    })
  } catch (e) {
    console.error('fetchContractServicePartnerDelete error', e)
    notification.error({ message: 'Delete failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTRACTSERVICEPARTNERS, fetchContractServicePartners),
    takeEvery(actions.FETCH_CONTRACTSERVICEPARTNER, fetchContractServicePartnerEdit),
    takeEvery(actions.SAVE_CONTRACTSERVICEPARTNER, fetchContractServicePartnerSave),
    takeEvery(actions.DELETE_CONTRACTSERVICEPARTNER, fetchContractServicePartnerDelete),
    takeEvery(actions.RE_FETCH_CONTRACTSERVICEPARTNERS, fetchContractServicePartnersRefresh),
  ])
}
